import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  class: "font-rows"
};
const _hoisted_2 = {
  class: "font-cell"
};
const _hoisted_3 = {
  class: "form-item"
};
const _hoisted_4 = {
  class: "form-item"
};
const _hoisted_5 = {
  class: "font-cell"
};
const _hoisted_6 = {
  class: "form-item"
};
const _hoisted_7 = {
  class: "form-item"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_input_number = _resolveComponent("el-input-number");
  const _component_el_color_picker = _resolveComponent("el-color-picker");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_select, {
    modelValue: $data.form.fontFamily,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.form.fontFamily = $event),
    onChange: $options.fontChange
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.fontfamilyoptions, item => {
      return _openBlock(), _createBlock(_component_el_option, {
        key: item.value,
        label: item.label,
        value: item.value
      }, null, 8, ["label", "value"]);
    }), 128))]),
    _: 1
  }, 8, ["modelValue", "onChange"])]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_input_number, {
    modelValue: $data.form.fontSize,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.form.fontSize = $event),
    "controls-position": "right",
    onChange: $options.fontChange
  }, null, 8, ["modelValue", "onChange"]), _cache[4] || (_cache[4] = _createElementVNode("span", {
    class: "unit"
  }, "px", -1))])]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createVNode(_component_el_select, {
    modelValue: $data.form.fontWeight,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.form.fontWeight = $event),
    onChange: $options.fontChange
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.fontweightoptions, item => {
      return _openBlock(), _createBlock(_component_el_option, {
        key: item.value,
        label: item.label,
        value: item.value
      }, null, 8, ["label", "value"]);
    }), 128))]),
    _: 1
  }, 8, ["modelValue", "onChange"])]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_color_picker, {
    modelValue: $data.form.color,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.form.color = $event),
    onChange: $options.fontChange
  }, null, 8, ["modelValue", "onChange"])])])]);
}